import { Typography } from "@mui/material";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Popover from "@mui/material/Popover";
import { useTheme } from "@mui/material/styles";
import * as React from "react";
import I18N from "../../../../../Wirtschaftswunder/oc-modules/oc-I18N/I18N";
import Booth from "../organisms/coreSidebar/Booth";
import Interiors from "../organisms/coreSidebar/Interiors";
import Message from "../organisms/popovers/Message";
import SaveIcon from "@mui/icons-material/Save";
import Dialog from "@mui/material/Dialog";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import SVG from "react-inlinesvg";
import IconButton from "@mui/material/IconButton";
import CancelIcon from '../styles/images/close-circle.svg';

const drawerWidth = '10%';
const drawerWidthExtended = '30%';

export function InspirationConfigurator() {
  const theme = useTheme();
  const history = useHistory();
  const exhibition = APP.arrangement?.state?.exhibition;
  const intTypes = APP.metadata.InteriorTypes.sort((a, b) => a.Displayed_Order - b.Displayed_Order);
  const booth = APP.arrangement?.state?.booth;
  const boothsets = APP.richMetadata.getAllBoothSets();
  const [activeGroup, setActiveGroup] = React.useState(window.innerWidth >= 1200 ? "Booth" : null);
  const [headerLabel, setHeaderLabel] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedBoothset, setCurrentBoothset] = React.useState(undefined);
  useEffect(() => {
    APP.currentBoothSet = selectedBoothset;
  }, [selectedBoothset]);

  useEffect(() => {
    if (booth) {
      const defaultBoothSetForBooth = _.first(booth.BoothsForBoothSets)?.BoothSet?.Name;
      setCurrentBoothset(APP.currentBoothSet ? APP.currentBoothSet : defaultBoothSetForBooth);
    }
  }, [booth]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  APP.on("ready", () => {
    if (APP.settings.userRole != "admin" && APP.arrangement) {
      APP.arrangement.setPopover({
        positionX: window.innerWidth / 2,
        positionY: window.innerHeight / 2,
        content: Message({
          message: I18N("inspiration saving not allowed"),
        }),
      });
    }
  });

  React.useEffect(() => {
    APP.initStagetoDOM();
  }, []);

  const handleWindowSizeChange = () => {
    setActiveGroup(window.innerWidth >= 1200 ? activeGroup : null);
    setHeaderLabel(headerLabel);
  };

  useEffect(() => {
    APP.initStagetoDOM();
    document.getElementById("sidebar-scroller").addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const group = APP.metadata.InteriorTypes.find((i) => i.Name == activeGroup);
    if (group) {
      setHeaderLabel(group.Displayed_Name);
    }
  }, [APP.settings.currentLang]);

  APP.on("savedConfiguration", () => {
    const code = APP.configuration.Code;
    history.push(`/${APP.arrangement.state.booth.id}/configurator/${code}`);
  });

  const handleScroll = (event) => {
    event.preventDefault();
    const element = $("#sidebar-scroller");
    const newScrollLeft = element.scrollLeft();
    const scrollWidth = element.get(0).scrollWidth;
    const width = element.width();
    const threshold = scrollWidth - newScrollLeft - width <= 8;
    if (threshold && window.innerWidth < 1200) {
      $("#scroll-gradient").hide();
    } else {
      $("#scroll-gradient").show();
    }
  };

  return (
    <Box sx={{ display: "flex", height: "calc(100% - 66px)" }}>
      {APP.arrangement?.popover && (
        <Popover
          open={!!APP.arrangement?.popover}
          onClose={() => APP.arrangement.setPopover(undefined)}
          anchorReference="anchorPosition"
          anchorPosition={{
            top: APP.arrangement?.popover ? APP.arrangement?.popover?.positionY : 0,
            left: APP.arrangement?.popover ? APP.arrangement?.popover?.positionX : 0,
          }}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
        >
          {APP.arrangement?.popover?.content ? APP.arrangement.popover.content() : undefined}
        </Popover>
      )}

      <CssBaseline />
      <Box
        variant="permanent"
        sx={{
          width: "100%",
          flexShrink: 0,
          position: "fixed",
          bottom: "50px",
          top: "auto",
          left: 0,
          right: 0,
          zIndex: 100,
          backgroundColor: "transparent",
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
          [theme.breakpoints.up("lg")]: {
            width: drawerWidth,
            position: "relative",
            bottom: "0",
          },
        }}
      >
        <Box
          id={"scroll-gradient"}
          sx={{
            background: "linear-gradient(270deg, #B8B8B8 0%, rgba(209, 209, 209, 0) 100%)",
            position: "absolute",
            zIndex: 9,
            width: "26px",
            height: "100%",
            top: 0,
            bottom: 0,
            right: 0,
            [theme.breakpoints.up("lg")]: {
              display: "none !important",
            },
          }}
        />
        <Box
          id={"sidebar-scroller"}
          sx={{
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            background: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(24px)",
            height: "100%",
            [theme.breakpoints.up("lg")]: {
              backgroundFilter: "none",
              background: "#fff",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "none",
              [theme.breakpoints.up("lg")]: {
                display: "block",
                padding: "26px",
              },
            }}
          >
            <img style={{ height: "100%", width: "100%" }} src={exhibition?.ExhibitionLogo} />
          </Box>
          {APP.arrangement?.dialog && (
            <Dialog
              open={true}
              onClose={() => {}}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              {APP.arrangement?.dialog?.content ? APP.arrangement.dialog.content() : undefined}
            </Dialog>
          )}

          <Box
            className={"config-sidebar"}
            sx={{
              display: "flex",
              flexDirection: {
                xs: "row",
                lg: "column",
              },
              alignItems: "center",
              height: "auto",
              borderTop: {
                xs: "1px solid #E2E2E2",
                lg: "none",
              },
              paddingLeft: 0,
            }}
          >
            {/* Start */}
            {intTypes.map((type) => {
              return (
                <Button
                  onClick={() => {
                    setHeaderLabel(type.Displayed_Name);
                    setActiveGroup(type.Name);
                  }}
                  key={type.Name}
                  color={"secondary"}
                  className={activeGroup == type.Name ? "selected" : ""}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "13px 20px",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                    height: "100%",
                    minWidth: "auto",
                    borderLeft: "2px solid transparent",
                    marginBottom: 0,
                    borderRadius: '100%',
                    [theme.breakpoints.up("lg")]: {
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "flex-start",
                      height: "auto",
                      padding: "13px 20px 13px 20px",
                      marginLeft: 0,
                      borderRadius: 0,
                      marginBottom: "10px",
                    },
                    [activeGroup === type.Name]: {
                      borderTop: "2px solid #C91113",
                      borderLeft: "none",
                      backgroundColor: "#F5F6FA",
                      [theme.breakpoints.up("lg")]: {
                        borderTop: "none",
                        borderLeft: "2px solid #C91113",
                      },
                    },
                    svg: {
                      fill: "#3A415A",
                      path: {
                        fill: "#3A415A",
                      },
                    },
                    "&:hover": {
                      svg: {
                        fill: "#C91113",
                        path: {
                          fill: "#C91113",
                        },
                      },
                      '.MuiBox-root': {
                        color: '#C91113',
                      },
                      [theme.breakpoints.up("lg")]: {
                        borderLeft: "2px solid #C91113",
                        backgroundColor: "#F5F6FA",
                      }
                    },
                    "&.selected": {
                      color: '#C91113',
                      svg: {
                        fill: "#C91113",
                        path: {
                          fill: "#C91113",
                        },
                      },
                      '.MuiBox-root': {
                        color: '#C91113',
                      },
                      [theme.breakpoints.up("lg")]: {
                        color: 'inherit',
                        borderLeft: "2px solid #C91113",
                        backgroundColor: "#F5F6FA",
                        '.MuiBox-root': {
                          color: 'inherit',
                        },
                      }
                    },
                    " .MuiButtonStartIcon": {
                      marginLeft: 0,
                      marginRight: 0,
                    },
                  }}
                  startIcon={
                    <SVG
                      style={{
                        height: "24px",
                        width: "24px",
                        marginBottom: 0,
                        marginLeft: 0,
                      }}
                      src={type.Icon}
                    />
                  }
                >
                  <Box
                    sx={{
                      marginLeft: 0,
                      marginTop: "6px",
                      color: "#3A415A",
                      textTransform: "initial !important",
                      [theme.breakpoints.up("lg")]: {
                        marginLeft: "17px",
                        marginTop: "0",
                      },
                    }}
                  >
                    {type.Displayed_Name}
                  </Box>
                </Button>
              );
            })}
            {/* End */}
          </Box>
        </Box>
      </Box>

      <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#fff",
            position: "fixed",
            bottom: "50px",
            zIndex: "100",
            display: "flex",
            flexDirection: "column",
            borderColor: "#E2E2E2",
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: "5px 5px 0 0",
            [theme.breakpoints.up("lg")]: {
              width: "20%",
              height: "100%",
              maxHeight: "calc(100% - 64px)",
              bottom: 0,
              borderWidth: "0 1px 0 1px",
            },
          }}
        >
          {activeGroup && renderCoreSidebar(activeGroup, exhibition, booth, headerLabel)}

          {activeGroup && (
            <IconButton
              onClick={() => {
                setActiveGroup(null);
                setHeaderLabel("");
              }}
              color={"secondary"}
              sx={{
                position: "absolute",
                right: "5px",
                top: "5px",
                zIndex: 101,
                display: { xs: "block", lg: "none" },
              }}
            >
              <SVG
                style={{
                  height: "24px",
                  width: "24px",
                }}
                src={CancelIcon}
              />
            </IconButton>
          )}
        </Box>

        <Box
          id="stage"
          className="stage"
          sx={{
            marginLeft: 0,
            position: "fixed",
            outline: "none",
            width: "100%",
            height: "calc(100% - 64px)",
            canvas: {
              width: "100%",
              border: "none",
              outline: "none",
            },
            [theme.breakpoints.up("lg")]: {
              marginLeft: "20%",
              width: `calc(100% - ${drawerWidthExtended})`,
            },
          }}
        />

        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            width: "100%",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
            padding: "7px",
            [theme.breakpoints.up("lg")]: {
              bottom: "3%",
              right: "3%",
              left: "unset",
              width: "auto",
              padding: 0,
              borderRadius: "8px",
            },
          }}
        >
          {/* <FormControl className="footer-select" sx={{ width: "350px" }} variant="filled" fullWidth> */}
        </Box>
        <Box
          sx={{
            position: "fixed",
            bottom: 50,
            right: 80,
          }}
        >
          <Stack spacing={1} direction="row">
            <FormControl
              className="footer-select"
              sx={{ width: "350px" }}
              variant="filled"
              fullWidth
            >
              <InputLabel id="demo-simple-select-label">{I18N("select boothset")}</InputLabel>
              <Select
                value={selectedBoothset || ""}
                label="select-exhibition"
                variant="filled"
                key="exhibition"
                onChange={(val) => {
                  setCurrentBoothset(val.target.value);
                  APP.currentBoothSet = val.target.value;
                  // if (APP.settings.userRole == "admin") setSaveBtnDisabled(false);
                }}
              >
                {boothsets?.map((boothset) => (
                  <MenuItem variant="h6" key={boothset.Name} value={boothset.Name}>
                    {boothset.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              disabled={APP.settings.userRole == "admin" && selectedBoothset ? false : true}
              sx={{ width: "150px" }}
              onClick={() => {
                APP.saveInspirationAction();
              }}
              variant="contained"
              endIcon={<SaveIcon />}
            >
              <Typography variant="h6">
                {APP.configuration?.Code ? I18N("Update") : I18N("Save")}
              </Typography>
            </Button>
          </Stack>
        </Box>
      </Box>
      {APP.arrangement?.dialog && (
        <Dialog
          open={true}
          fullScreen={APP.arrangement.dialog?.fullScreen}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          {APP.arrangement?.dialog?.content ? APP.arrangement.dialog.content() : undefined}
        </Dialog>
      )}
    </Box>
  );
}

function renderCoreSidebar(activeGroup, exhibition, booth) {
  switch (activeGroup) {
    case "booth":
      return <Booth booth={booth}></Booth>;
    default:
      return <Interiors exhibition={exhibition} type={activeGroup} />;
  }
}
